import {type AxiosResponse} from "axios";
import {deleteRequest, get} from "../../../infrastructure/api";
import {mobileConfigurationByIdEndpoint} from "../endpoints";
import {ListEndpoint} from "./endpoints";
import {type Configuration} from "../types";
import {type ApiResponse} from "../../../infrastructure/types";

export const fetchList = async (): Promise<AxiosResponse<ApiResponse<Configuration[]>>> =>
  await get({endpoint: ListEndpoint.all});

export const deleteConfiguration = async (id: number) =>
  await deleteRequest({endpoint: mobileConfigurationByIdEndpoint(id)});

export const downloadZip = async (id: number) =>
  await get({
    endpoint: ListEndpoint.zip(id),
    headers: {"Content-Type": "application/zip"},
    responseType: "blob"
  });
